import * as types from '../common/types'

export const clearLists = (lists: object[]) => ({
  type: types.CLEAR_LISTS,
  lists
})

export const clearAllLists = () => ({ type: types.CLEAR_ALL_LISTS })

export const setLoadedLists = (result: object) => ({
  type: types.SET_LOADED_LISTS,
  overwrite: true,
  lists: result
})

export const setLoadedList = (
  listId: string,
  data: object,
  overwrite = true
) => ({
  type: types.SET_LOADED_LIST,
  listId,
  overwrite,
  data
})

export const setLoadedItemDetail = (
  listId: string,
  data: object,
  overwrite = true
) => ({
  type: types.SET_LOADED_ITEM_DETAIL,
  listId,
  overwrite,
  data
})

export const setLoadedListItem = (listId: string, data: object) =>
  setLoadedList(listId, [data], false)

export const initDataFetch = (id: string) => ({
  type: types.INIT_DATA_FETCH,
  id
})

export const setDataFetchResponse = (id: string, response: object) => ({
  type: types.SET_DATA_FETCH_RESULT,
  id,
  response
})

export const setDataFetchError = (id: string, error: object) => ({
  type: types.SET_DATA_FETCH_ERROR,
  id,
  error
})
